import { FC, PropsWithChildren } from 'react';
import { SentryContext } from './sentry-context';

export type SentryContextProviderProps = PropsWithChildren & {
  enabled: boolean;
};

export const SentryContextProvider: FC<SentryContextProviderProps> = ({
  enabled,
  children,
}) => {
  return <SentryContext.Provider value={{ enabled }}>{children}</SentryContext.Provider>;
};
